import Component from 'inferno-component';
import { Modal, Header } from 'semantic-ui-react';

export default class Imprint extends Component {
  render() {
    return (
      <Modal closeIcon trigger={<p style={{color: 'white', cursor: 'pointer'}}>Impresszum</p>}>
        <Modal.Header>Impresszum</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <Header>Szolgáltató</Header>
            <p style={{marginBottom: "2rem"}}>
              UnivAdvert Kft.<br />
              6600 Szentes, Dózsa György utca 115.<br/>
              <strong>Képviselő:</strong> Bögöthy Gábor<br/>
              <strong>email:</strong> bogothy.gabor@univadvert.hu<br/>
              <strong>Adószám:</strong> 26097620-2-06<br/>
              <strong>Cégjegyzékszám:</strong> 06-09-023748<br/>
              <strong>Bankszámlaszám:</strong> 11735043-23534179-00000000<br/>
            </p>
          </Modal.Description>
          <Modal.Description>
            <Header>Tárhelyszolgáltató</Header>
            <p>
              Oros-Com Kft.<br/>
              5600, Orosháza, Nagyatádi utca 43.<br/>
              <strong>Adószám:</strong> 13408556-2-04<br/>
              <strong>Cégjegyzékszám:</strong> 04-09-006548<br/>
            </p>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/imprint/Imprint.js